module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.7667046.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-regular-400.woff
// module id = bZM5
// module chunks = 12